import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const BundleLazy = loadable(() => import(/* webpackChunkName: "Bundle" */ './BundleSuspense'));

export const BundleAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <BundleLazy />
    </DelayedSuspense>
);
